import api from '@pray/shared/utils/api';

import type { DeleteSeedsResponse } from './types';

const SEEDS_URL = '/web/studio/admin/seed-emails/seeds';

/**
 * Soft-deletes a batch of seeds. The answer carries how long they stay restorable, which is what
 * makes the Undo in the notice a real offer rather than a hope.
 */
export async function deleteSeeds(seedIds: string[]) {
  const res = await api.executeDeleteRequest<{ data: DeleteSeedsResponse }>(SEEDS_URL, {
    seed_ids: seedIds,
  });
  return res.data.data;
}
